import { Col, FormGroup, FormLabel, Row } from "react-bootstrap";
import InputText from "../../../components/Forms/Element/InputText";
import StatusCheckBox from "../../../components/Common/StatusCheckbox";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { convertStatusToBoolean } from "../../../../utils/ConverterUtils";
import DreGroupSelect from "../../../components/Custom/CashFlow/Category/DreGroupSelect";
import TextArea from "../../../components/Forms/Element/TextArea";
import AsteriskRequired from "../../../components/Common/AsteriskRequired";
import axiosInstance from "../../../../services/AxiosInstance";
import Api from "../../../../constants/Api";
import FormSection from "../../../components/Common/Form/FormSection";

const Form = (props) => {

    const { t } = useTranslation();
    const { status, setStatus, formik, entityData } = props;

    useEffect(() => {
        // Preenche os valores nos campos.
        if (entityData != null) {
            formik.setFieldValue('name', entityData.name);
            formik.setFieldValue('description', entityData.description);

            // Preenche o select de grupo DRE
            if (entityData.dreGroup !== null) {
                // Busca o label correto para o grupo DRE
                axiosInstance.get(`${Api.cash_flow.category}/dre-groups/${entityData.dreGroup}`).then(response => {
                    formik.setFieldValue('dreGroup', {
                        value: entityData.dreGroup,
                        label: response.data.name
                    });
                });
            }

            // Define o status na tela
            setStatus(convertStatusToBoolean(entityData.status));
        }
    }, [entityData]);

    return (
        <>
            <div className="form-layout form-layout--spaced">
                <FormSection
                    title={t('basic_information')}
                    description={t('cash_flow_category_basic_information_hint')}
                    icon="fa-solid fa-folder-tree"
                >

                    <Row className="g-3">
                        <Col md={6}>
                            <FormGroup>
                                <FormLabel>{t('name')} <AsteriskRequired/></FormLabel>
                                <InputText
                                    name="name"
                                    placeholder={t('category_name_placeholder')}
                                    maxLength={50}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.name}
                                    error={formik.errors.name}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <FormLabel>{t('cash_flow.dre_group')} <AsteriskRequired/></FormLabel>
                                <DreGroupSelect
                                    name="dreGroup"
                                    onChange={(value) =>
                                        formik.setFieldValue('dreGroup', value)
                                    }
                                    value={formik.values.dreGroup}
                                    onBlur={formik.handleBlur}
                                    error={formik.errors.dreGroup}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row className="g-3 mt-0">
                        <Col md={12}>
                            <FormGroup>
                                <FormLabel>{t('description')}</FormLabel>
                                <TextArea
                                    name="description"
                                    placeholder={t('description_placeholder')}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.description}
                                    maxLength={255}
                                    style={{ height: "100px" }}
                                    counter="true"
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </FormSection>

                <FormSection
                    compact
                    title={t('status')}
                    description={t('cash_flow_category_status_hint')}
                    icon="fa-solid fa-toggle-on"
                >

                    <Row>
                        <Col md={12}>
                            <FormGroup className="mb-0">
                                <StatusCheckBox
                                    name="status"
                                    checked={status}
                                    onChange={() => setStatus(!status)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </FormSection>
            </div>
        </>
    );
}

export default Form;
